import React, {useEffect, useState} from "react";
import FirstCoachTable from "./components/firstcoachtable";

const ManageCoachMain : React.FC<any>  = (props) => {


    return (
        <div>
            <FirstCoachTable />
        </div>
    )
}

export default ManageCoachMain;